'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, RefObject } from 'react';
import MobileCaseMediaLink from '@/components/Partnership/CasesSliderScroll/MobileCaseMediaLink';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { useCasesSliderMobileReveal } from '../hooks/useCasesSliderMobileReveal';
import css from '../style.module.scss';
import { CasesScrollItemDto } from '../types';
interface Props {
  cases: CasesScrollItemDto[];
  sectionRef: RefObject<HTMLElement | null>;
  className?: string;
}
const CasesSliderMobile: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    cases,
    sectionRef,
    className
  } = t0;
  useCasesSliderMobileReveal(sectionRef, true, cases.length);
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.mobileSection, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cases) {
    t2 = cases.map(_temp);
    $[2] = cases;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className={css.mobileList}>{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== sectionRef || $[7] !== t1 || $[8] !== t3) {
    t4 = <section ref={sectionRef} className={t1}>{t3}</section>;
    $[6] = sectionRef;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default CasesSliderMobile;
function _temp(slide, i) {
  return <article key={`${slide.slideTitle}-${i}`} className={css.mobileCard}><div className={css.topContent}><Typography className={css.tabLabel} variant="h5" tag="h2">{slide.tabLabel}</Typography><div className={css.tabDescriptionWrap}><Typography className={css.tabDescription} variant="body-s" tag="div">{typeof slide.tabDescription === "string" ? slide.tabDescription : slide.tabDescription ? <StrapiRichContent content={slide.tabDescription} /> : null}</Typography></div></div><MobileCaseMediaLink slide={slide} /><div className={css.bottomContent}><div className={css.rightDescription}><Typography className={css.bottomDescription} variant="body-s" tag="div">{typeof slide.slideDescription === "string" ? slide.slideDescription : slide.slideDescription ? <StrapiRichContent content={slide.slideDescription} /> : null}</Typography></div><Typography uppercase={true} className={css.bottomTitle} variant="body-s" tag="h3">{slide.slideTitle}</Typography></div></article>;
}